

const ENKanban = {
	"Adicionar coluna": "Add column",
	"Adicionar kanban": "Add kanban",
	"Alterar kanban": "Update",
	"Ações disponíveis": "Available actions",
	"Concluído": "Completed",
	"Criar novo kanban": "Create new kanban",
	"Clique para adicionar uma coluna": "Click to add a column",
	"Coluna excluída com sucesso": "Column successfully deleted",
	"Deseja realmente excluir o kanban": "Do you really want to delete the kanban",
	"Definir como modo de visualização padrão": "Set as default view",
	"Deseja realmente excluir a coluna": "Do you really want to delete the column",
	"Em andamento": "In progress",
	"Exclusão de coluna": "Delete column",
	"Esta coluna possui ações vinculadas": "This column has linked actions",
	"Erro ao adicionar kanban": "Error adding kanban",
	"Erro ao alterar kanban": "Error changing kanban",
	"Erro ao atualizar coluna": "Error updating column",
	"Erro ao carregar colunas": "Error loading columns",
	"Erro ao excluir kanban": "Error deleting kanban",
	"Erro ao inserir coluna": "Error inserting column",
	"Erro ao remover coluna": "Error removing column",
	"Erro carregar kanbans": "Error loading kanbans",
	"Este kanban possui ações vinculadas": "This kanban has linked actions",
	"Exclusão de Kanban": "Delete kanban",
	"Exibir ações": "Show actions",
	"Exibir kanbans": "Show kanbans",
	"Kanban excluído com sucesso": "Kanban successfully deleted",
	"Kanban padrão": "Default kanban",
	"Kanbans dinâmicos": "Dynamic kanbans",
	"Não iniciado": "Not started", 
	"Nenhum card selecionado": "No card selected",
	"Nenhuma ação disponível": "No actions available",
	"Nova coluna": "New column",
	"Por favor, preencha os campos obrigatórios acima": "Please fill the required fields above",
	"Selecione um projeto": "Select a project",
	"Selecione uma sprint": "Select a sprint",
	"ou arraste uma ação e solte aqui": "or drag an action and drop here",
	"Modo de visualização padrão atualizado com sucesso": "Default view successfully updated",
	"Selecione um card para ver seus detalhes": "Select a card to see its details"
};


export default ENKanban;
